import PropTypes from 'prop-types';
import Arrow from '../../../components/Arrow';
import { AlignTravel, ArrowLink, Grid } from '../../../components/ArrowLink';
import ArrowSrc from '../../../images/arrowRightDark.svg';
import { linkPropTypes } from '../constants';

const SearchLink = ({ path, text }) => (
  <ArrowLink
    activeStyle={{
      color: 'black',
      fontWeight: 'bold',
    }}
    href={path}
  >
    <AlignTravel>
      <p>{text}</p>
    </AlignTravel>
    <Arrow alt={'arrow'} parentHover={ArrowLink} src={ArrowSrc} />
  </ArrowLink>
);

const LinkList = ({ links }) => (
  <Grid>
    {links.map((link) => {
      const path = `/search/${link.origin.slug}/${link.destination.slug}`;

      return (
        <SearchLink
          key={path}
          path={path}
          text={`${link.origin.name} - ${link.destination.name}`}
        />
      );
    })}
  </Grid>
);

SearchLink.propTypes = {
  path: PropTypes.string,
  text: PropTypes.string,
};

LinkList.propTypes = {
  links: PropTypes.arrayOf(linkPropTypes),
};

export { LinkList };
